import {MessageEntity} from "@ots-frontend/ots-data";
import {Box, Button, Divider, Modal, ModalProps, Skeleton} from "@mantine/core";
import {Comment, makeCommentProps} from "../Comment/Comment";
import {Empty} from "../../empty/Empty/Empty";
import {useTranslation} from "react-i18next";
import {HasAccess} from "../../auth/HasAccess/HasAccess";

const EMPTY_ARRAY: MessageEntity[] = []

export type CommentListProps = {
  comments?: MessageEntity[]
  isLoading?: boolean;
  onAddComment?: () => void
  addCommentLabel?: string
  onEdit?: (message: MessageEntity) => void
  onDelete?: (message: MessageEntity) => void
  empty?: {
    show?: boolean
    message: string
  }
}

export const CommentList = (props: CommentListProps) => {

  const {t} = useTranslation(["common"])

  const {
    comments = EMPTY_ARRAY,
    isLoading = false,
    onAddComment,
    onEdit,
    onDelete,
    empty = {
      show: true,
      message: t<string>("common.entity.message.list.empty", "No Comments"),
    }
  } = props

  return (
    <Box>
      {isLoading &&
        <>
          <Skeleton height={50} circle mb="xl"/>
          <Skeleton height={8} radius="xl"/>
          <Skeleton height={8} mt={6} radius="xl"/>
          <Skeleton height={8} mt={6} width="70%" radius="xl"/>
        </>
      }
      {(empty.show && comments.length === 0) &&
        <Empty
          maw={400}
          h={100}
          mx="auto"
          message={empty.message}
          action={
            <HasAccess permissions={["edit"]}>
              {onAddComment &&
                <Button onClick={() => onAddComment()}>
                  {props.addCommentLabel ?? t("common.action.add.comment", "Add Comment")}
                </Button>
              }
            </HasAccess>
          }/>
      }
      {comments.map((m, i) => {
        return (
          <>
            <Comment {...makeCommentProps(m, onEdit, onDelete)} p="md"/>
            {(i !== comments.length - 1) &&
              <Divider variant="dotted"/>
            }
          </>
        )
      })}
    </Box>
  )
}

export interface CommentListModalProps extends ModalProps {
  listProps: CommentListProps
}

export const CommentListModal = (props: CommentListModalProps) => {
  const {t} = useTranslation(["common"])

  const {
    title = t<string>("common.modal.commentlist.title", "Comments"),
    listProps,
    ...rest
  } = props;

  return (
    <Modal {...rest} title={title}>
      <Box>
        <CommentList {...listProps} />
      </Box>
    </Modal>
  );
};
